import * as React from 'react';

import { withIntl, IntlProps } from 'ha/i18n';
import SupplyPageIcon from './SupplyPageIcon';

const Icons: React.SFC<IntlProps> = ({ intl: { T } }) => (
  <div className="container-grid m-t-2_5">
    <div className="row m-x-0 flex-align-center m-b-2_5">
      <div className="col-xs-8 p-r-2">
        <SupplyPageIcon
          iconName="financial-report"
          text={T('Thousands of high-quality, high-paying verified users.')}
        />
      </div>
      <div className="col-xs-8 p-x-1">
        <SupplyPageIcon
          iconName="lock"
          text={T(
            "First's months rent is guaranteed. We keep your money safe.",
          )}
        />
      </div>
      <div className="col-xs-8 p-l-2">
        <SupplyPageIcon
          iconName="chat-group"
          text={T('Multilingual customer care team that is ready to help you')}
        />
      </div>
    </div>
    <div className="line line--thin back-grey" />
  </div>
);

export default withIntl(Icons);
